<template>
    <button class="remove-button-styling" @click.prevent="openBirdsEyeModal()">
        <BaseIcon color="#6B7B23" height="40" stroke-width="1.5" width="40">
            <IconPlaneTilt />
        </BaseIcon>
        <p class="uk-margin-remove" style="color: #6B7B23;">Aerial</p>
    </button>
</template>

<script setup>

import BaseIcon from "./BaseIcon";
import IconPlaneTilt from "../icons/IconPlaneTilt.vue";

const props = defineProps({
    url: String
})

function openBirdsEyeModal() {
    $('#modal-birds-eye-iframe').attr('src', props.url)

    UIkit.modal('#modal-birds-eye', {stack: true}).show()
}
</script>
